<template>
  <div :class="sectionClass">
    <label :for="id" class="form-label" v-if="labelshow">{{ label }}</label>
    <InputText
      :id="id"
      :type="type"
      :value="modelValue"
      :disabled="disabled"
      :placeholder="placeholder"
      :minlength="minlength"
      :maxlength="maxlength"
      class="w-full"
      :class="{
        'p-invalid':
          (validated && customfield && validation) ||
          (validation && validation.$error),
      }"
      :aria-describedby="`${id}-help`"
      @input="$emit('update:modelValue', $event.target.value)"
    />
    <span
      v-if="
        (validated && customfield && validation) ||
        (validation?.$error &&
          validation.required &&
          validation.required.$invalid)
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.$message.replace("Value", this.label) }}
    </span>
    <span
      v-else-if="
        (validated && customfield && validation) ||
        (validation?.$error &&
          validation.requiredIf &&
          validation.requiredIf.$invalid)
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.$message.replace("The value", this.label) }}
    </span>
    <span
      v-else-if="
        (validated && customfield && validation) ||
        (validation?.$error && validation.min && validation.min.$invalid)
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.$message }}
    </span>
    <span
      v-else-if="
        (validated && customfield && validation) ||
        (validation?.$error && validation.max && validation.max.$invalid)
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.$message }}
    </span>
    <span
      v-else-if="
        (validated && customfield && validation) ||
        (validation?.$error && validation.email && validation.email.$invalid)
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.$message.replace("Value", this.label) }}
    </span>
    <span
      v-else-if="
        (validated && customfield && validation) ||
        (validation?.$error &&
          validation.numeric &&
          validation.numeric.$invalid)
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.$message }}
    </span>
    <span
      v-else-if="
        (validated && customfield && validation) ||
        (validation?.$error && validation.sameAs && validation.sameAs.$invalid)
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.$message }}
    </span>
    <!-- <span
      v-else-if="
        validation.$error && validation.requiredIf && validation.requiredIf.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.requiredIf.$message.replace(" ", this.label) }}
    </span>
    <span
      v-else-if="
        validation.$error && validation.email && validation.email.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.email.$message }}
    </span>
    <span
      v-else-if="validation.$error && validation.min && validation.min.$invalid"
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.min.$message }}
    </span>

   
    <span
      v-else-if="
        validation.$error && validation.numeric && validation.numeric.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.numeric.$message }}
    </span> -->
  </div>
</template>

<script>
export default {
  props: {
    sectionClass: {
      type: String,
      default: "field",
    },
    id: {
      type: String,
      required: true,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    label: {
      type: String,
      required: true,
      default: "",
    },
    customfield: {
      type: Boolean,
      default: false,
    },
    validated: {
      type: Boolean,
      default: false,
    },
    validation: {
      type: Object,
      required: false,
    },
    minlength: {
      type: String,
      default: "",
    },
    maxlength: {
      type: String,
      default: "",
    },
    modelValue: {
      type: [String, Number],
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    labelshow: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
